import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'

export const toggleAcquireNumberDisplay = (payload = null) => (dispatch) =>
  dispatch({
    type: ActionType.PhoneNumbers.TOGGLE_ACQUIRE_NUMBER_DISPLAY,
    payload,
  })

// export const changeAreaCode = payload => dispatch =>
//   dispatch({
//     type: ActionType.PhoneNumbers.CHANGE_AREA_CODE,
//     payload,
//   })

export const selectUseCase = payload => dispatch =>
  dispatch({
    type: ActionType.PhoneNumbers.SELECT_USE_CASE,
    payload,
  })

export const selectNewPhoneNumber = (payload) => (dispatch) =>
  dispatch({
    type: ActionType.PhoneNumbers.SELECT_NEW_PHONE_NUMBER,
    payload,
  })

export const selectDefaultPhoneNumber = (payload) => (dispatch) =>
  dispatch({
    type: ActionType.PhoneNumbers.SELECT_DEFAULT_PHONE_NUMBER,
    payload,
  })

export const searchAvailablePhoneNumbers =
  (areaCode, countryCode) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch({
        type: ActionType.PhoneNumbers.SEARCH_AVAILABLE_PHONE_NUMBERS_REQUEST,
        areaCode,
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(
            `${API_URL}/phonenumbers/available?areacode=${areaCode}&isocountry=${countryCode}`,
            {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            },
          )
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.PhoneNumbers
                    .SEARCH_AVAILABLE_PHONE_NUMBERS_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.PhoneNumbers
                  .SEARCH_AVAILABLE_PHONE_NUMBERS_SUCCESS,
                payload,
                areaCode,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.PhoneNumbers
                  .SEARCH_AVAILABLE_PHONE_NUMBERS_FAILURE,
                payload: error,
                areaCode,
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })
